var Path = require('./path');
/**
 *
 * @param {Object} o
 * @param {String} path
 * @returns {*}
 */


module.exports = function (o, path) {
  if (typeof path !== 'string') {
    throw new TypeError('path must be a string');
  }

  if (typeof o !== 'object') {
    throw new TypeError('object must be passed');
  }

  var pathObj = Path.get(path);

  if (!pathObj.valid) {
    throw new Error('path is not a valid object path');
  }

  return pathObj.getValueFrom(o);
};